/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Form/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LastModifiedBy from './LastModifiedBy/index'
import LineWithDot from './LineWithDot/index'
import Name from './Name/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Form({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/MedicalFormSelector/Content/Form"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  closePopover,
  viewPath
  
})
let formItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'form_item',
path: 'isFirst',
})
  return (<React.Fragment
>
<button
  data-testid="Form.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--g-1-9F4O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-2-9F4O': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-9F4O': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<LineWithDot
  viewPath={`${viewPath}/LineWithDot`}
/>
<div
  data-testid="Form.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Form.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-9F4O': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<fromFlow.When is={formItemIsFirstValueData}>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 data="form_item.isFirst"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Current"
/>
)}
</TysiaTag>
</fromFlow.When>
</div>
<LastModifiedBy
  viewPath={`${viewPath}/LastModifiedBy`}
/>
</div>
</button>
{children}
</React.Fragment>)
}